import { APP_QUERY_PARAMETER } from 'modules/app/constants/index.js'
import replaceRouterAction from 'modules/router/actions/replace/index.js'
import { updateUtmSourceAppAction } from 'modules/app/actions/updateUtmSource/index.js'
import { logUtil } from 'packages/src'
import { getAndPersistPlatformAppAction } from 'modules/app/actions/get-and-persist-platform/index.js'

/**
 * @param props
 * @param props.location
 */
const initAppQueryParametersAppAction = (props) => {
  return (dispatch) => {
    logUtil('initAppQueryParametersAppAction').debug('[start] props=', props)

    const { location } = props
    const queryString = require('query-string')
    const query = queryString.parse(location.search)

    if (query[APP_QUERY_PARAMETER.TRAINING_JWT]) {
      delete query[APP_QUERY_PARAMETER.TRAINING_JWT]
      delete query[APP_QUERY_PARAMETER.TRAINING_JTI]
    }

    const utmSource = query[APP_QUERY_PARAMETER.UTM_SOURCE]
    if (utmSource) {
      dispatch(updateUtmSourceAppAction(utmSource))
    }

    const platform = query[APP_QUERY_PARAMETER.PLATFORM]
    dispatch(getAndPersistPlatformAppAction(platform))

    let url = location.pathname
    if (Object.keys(query).length) {
      url += `?${queryString.stringify(query)}`
    }
    dispatch(replaceRouterAction(url))

    logUtil('initAppQueryParametersAppAction').debug('[done]')
  }
}

export default initAppQueryParametersAppAction
